import React from "react";
import { connect } from "react-redux";
import "./index.scss";

const ApprovalProcess = () => {
  return (
    <div className="approval-container">
      <iframe
        src="//122.112.209.225:10013/flowable-modeler/"
        width="100%"
        height="100%"
        frameBorder={0}
      ></iframe>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(ApprovalProcess);
